module.exports = __webpack_public_path__ + "static/img/banner-01.731bfdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/mobile/banner-01.png
// module id = 7/f4
// module chunks = 1